var map = {
	"./1_Platz_PH2_Winter2024.jpg": 510,
	"./3 Platz Rglt Hambach.jpg": 586,
	"./A Mannschaft VR2024.jpg": 958,
	"./Krebs30032025.jpg": 626,
	"./MeisterVRHerbst2024.jpg": 747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;